import { useGlobalQuery } from 'state/query-client/hooks';
import {
  AgentIntegrationOverviewResponse,
  getAgentIntegrationsOverview,
} from 'services/integration-service';
import { useConfig } from './use-config';

export const useGetAgentIntegrationsOverview = (agentId: string) => {
  const { configurationSettings } = useConfig();

  return useGlobalQuery<AgentIntegrationOverviewResponse>({
    queryKey: ['agentIntegrationsOverview', agentId],
    queryFn: async () => {
      if (!configurationSettings) {
        throw new Error('Configuration settings are not available');
      }

      return getAgentIntegrationsOverview(configurationSettings, agentId);
    },
    enabled: !!configurationSettings && !!agentId,
  });
};
